import { render } from "./UsersDashboardComponent.vue?vue&type=template&id=895cf628&scoped=true"
import script from "./UsersDashboardComponent.vue?vue&type=script&lang=js"
export * from "./UsersDashboardComponent.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-895cf628"

export default script